module.exports = __webpack_public_path__ + "static/media/join-free.5c7b745a.svg";